/**
 * PropertyRequestWizard.js
 *
 * Flow (7 steps):
 *   Step1_Intent → Step2_Budget → Step3_Specs (specs + amenities)
 *   → Step4_GeoFeatures → Step5_GeoScope (neighborhoods + commute)
 *   → Step6_Household → Step7_Review
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepIndicator from './components/StepIndicator';
import Step1_Intent      from './steps/Step1_Intent';
import Step2_Budget      from './steps/Step2_Budget';
import Step3_Specs       from './steps/Step3_Specs';
import Step4_GeoFeatures from './steps/Step4_GeoFeatures';
import Step5_GeoScope    from './steps/Step5_GeoScope';
import Step6_Household   from './steps/Step7_Household';
import Step7_Review      from './steps/Step8_Review';
import './PropertyRequestWizard.css';

const STEP_LABELS = [
    'هدف',              // 1
    'بودجه',            // 2
    'مشخصات',           // 3
    'ترجیحات محیطی',    // 4
    'محدوده جغرافیایی', // 5  neighborhoods + commute merged
    'خانوار',           // 6
    'بررسی',            // 7
];

const TOTAL_STEPS = 7;

export default function PropertyRequestWizard() {
    const navigate = useNavigate();
    const [step,      setStep]      = useState(1);
    const [requestId, setRequestId] = useState(null);
    const [draftData, setDraftData] = useState({});

    const mergeDraft = (patch) => setDraftData(prev => ({ ...prev, ...patch }));

    const handleStep1Next = (id, data) => {
        setRequestId(id);
        mergeDraft(data);
        setStep(2);
    };

    const handleNext = (data = {}) => {
        mergeDraft(data);
        setStep(s => Math.min(s + 1, TOTAL_STEPS));
    };

    const handleBack = () => setStep(s => Math.max(s - 1, 1));
    const handleDone = () => navigate('/search');

    const stepProps = { requestId, onBack: handleBack, initialData: draftData };

    return (
        <div className="prw-page" dir="rtl">
            <div className="prw-container">

                <header className="prw-header">
                    <h1 className="prw-title">درخواست ملک</h1>
                    <p className="prw-subtitle">
                        مشخصات ملک مورد نظر خود را وارد کنید تا بهترین گزینه‌ها را برای شما پیدا کنیم.
                    </p>
                </header>

                <StepIndicator currentStep={step} totalSteps={TOTAL_STEPS} labels={STEP_LABELS} />

                <div className="prw-step-body">
                    {step === 1 && <Step1_Intent onNext={handleStep1Next} initialData={draftData} />}
                    {step === 2 && <Step2_Budget   {...stepProps} intent={draftData.intent} onNext={d => handleNext(d)} />}
                    {step === 3 && <Step3_Specs    {...stepProps} onNext={d => handleNext(d)} />}
                    {step === 4 && <Step4_GeoFeatures {...stepProps} onNext={d => handleNext(d)} />}
                    {step === 5 && <Step5_GeoScope    {...stepProps} onNext={d => handleNext(d)} />}
                    {step === 6 && <Step6_Household   {...stepProps} onNext={d => handleNext(d)} />}
                    {step === 7 && (
                        <Step7_Review
                            requestId={requestId}
                            draftData={draftData}
                            onBack={handleBack}
                            onDone={handleDone}
                        />
                    )}
                </div>

            </div>
        </div>
    );
}
